import { useEffect, useState } from 'react';
import rtlDetect from 'rtl-detect';

import { englishLocaleKey, IntlMessages } from '@app/constants';

import { getIntlMessages } from './getIntlMessages';
import { useAppLocale } from './useAppLocale';

export const useLocaleConfig = () => {
  const { locale: localStorageLocale } = useAppLocale();
  const [localeConfig, setLocaleConfig] = useState<{
    locale?: string;
    messages?: IntlMessages;
  }>({});

  const updateLocaleConfig = (locale: string, messages: IntlMessages) => {
    setLocaleConfig({ locale, messages });
    document.documentElement.setAttribute('lang', locale);
    document.documentElement.setAttribute('dir', rtlDetect.getLangDir(locale));
  };

  const getLocaleConfig = (selectedLocale: string) => {
    if (!selectedLocale) {
      return;
    }

    getIntlMessages(selectedLocale)
      .then(translation =>
        updateLocaleConfig(selectedLocale, translation.default)
      )
      .catch(() => updateLocaleConfig(englishLocaleKey, {}));
  };

  useEffect(() => {
    getLocaleConfig(localStorageLocale);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorageLocale]);

  return localeConfig;
};
